module.exports = __webpack_public_path__ + "Server-Healthy.Ftp.d5c8f1b941272cab6e0b7b6d8e437fa0.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Healthy.Ftp.png
// module id = 1248
// module chunks = 1